import { format, parse } from 'date-fns';
import { stripHtml } from 'string-strip-html';
import moment from 'moment';
import constants from './constants';

export default {
  name: 'utilityFunctions',
  data() {
    return {
      formatMarkdown: () => [{
        type: 'output',
        filter(text) {
          let returnText = text;
          // remove paragraphs
          returnText = returnText.replace(/<\/?p[^>]*>/g, '');
          // add pvd styles
          returnText = returnText.replace(/<ol>/g, '<ol class="pvd-list-number">');
          returnText = returnText.replace(/<ul>/g, '<ul class="pvd-list-bullet">');
          returnText = returnText.replace(/<\/a>/g, ' <pvd-icon icon="new-tab"></pvd-icon></a>');
          return returnText;
        },
      }],
    };
  },
  computed: {
    computedExitUrl() {
      let exitUrl;
      if (this.$globalData && this.$globalData.tStoreResponse && this.$globalData.tStoreResponse.exitURL) {
        exitUrl = this.$globalData.tStoreResponse.exitURL.url;
      } else {
        exitUrl = this.pd_content.overlay_exit_link.all_accounts_url;
      }
      return exitUrl;
    },
    showSAI() {
      const productCodes = ['TASMA', 'IBSMA', 'SMAFIM'];
      const smaStrategyCodes = ['TASMALD', 'IBSMALD', 'BCA-IMUSMALD'];
      if (smaStrategyCodes.includes(this.pd_pageData.tStoreResponse.params.smaStrategyCd) && (this.pd_pageData.tStoreResponse.params.productType === 'MASMA' || productCodes.includes(this.pd_pageData.tStoreResponse.params.productType))) {
        return false;
      }
      switch (this.pd_pageData.tStoreResponse.params.productType) {
        case 'UFD':
        case 'MASMA':
        case 'EISMA':
        case 'LCSMA':
        case 'FESMA':
        case 'AESMA':
        case 'XISMA':
        case 'ETFBDI':
        case 'ETFMAI':
          return true;
        default:
          return false;
      }
    },
    getEReviewNum() {
      switch (this.pd_pageData.tStoreResponse.params.productType) {
        case 'UFD':
          return this.pd_content.rc_spray_ereview.UMA;
        case 'MASMA':
          return this.pd_content.rc_spray_ereview.MASMA;
        case 'ETFBDI':
        case 'ETFMAI':
          return this.pd_content.rc_spray_ereview.blackrock;
        default:
          return this.pd_content.rc_spray_ereview.SMA;
      }
    },
  },
  methods: {
    formatTextualDate(dateString) {
      return format(parse(dateString), 'MMMM DD, YYYY');
    },
    isIrrevocableRegType(regType) {
      const subTrustRegTypes = ['IRT', 'CHAR', 'CLT', 'CRT', 'CRAT', 'CRUT', 'IT', 'SFT', 'CGF', 'GRAT', 'CHTE'];
      return subTrustRegTypes.includes(regType);
    },
    getSecurityNumber(gNumber, ssn) {
      if (gNumber && this.isManaged(this.routeId)) {
        return gNumber;
      }
      return ssn;
    },
    openWindow(url, target, w, h) {
      const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
      const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
      const width = this.$_windowWidth();
      const height = this.$_windowHeight();
      const left = ((width / 2) - (w / 2)) + dualScreenLeft;
      const top = ((height / 2) - (h / 2)) + dualScreenTop;
      const newWindow = window.open(url, target, `scrollbars=yes, width=${w}, height=${h}, top=${top}, left=${left}`);

      if (window.focus) {
        newWindow.focus();
      }
      return newWindow;
    },
    $_windowWidth() {
      let width;
      if (window.innerWidth) {
        width = window.innerWidth;
      } else if (document.documentElement.clientWidth) {
        width = document.documentElement.clientWidth;
      } else {
        ({ width } = window.screen);
      }
      return width;
    },
    $_windowHeight() {
      let height;
      if (window.innerHeight) {
        height = window.innerHeight;
      } else if (document.documentElement.clientHeight) {
        height = document.documentElement.clientHeight;
      } else {
        ({ height } = window.screen);
      }
      return height;
    },
    captureHTML() {
      const docHTML = document.getElementsByTagName('html')[0];

      const { outerHTML } = docHTML;
      const { origin } = window.location;
      const hrefForCSS = `href="${origin}/stgw/`;
      let archiveHTML = `<!DOCTYPE html>${outerHTML.replace(/href="\/stgw\//gi, hrefForCSS)}`;
      archiveHTML = archiveHTML.replace(/<img.*?>/gi, '');
      if (!this.isNetBenefits()) {
        archiveHTML = this.addHeader(archiveHTML);
      }
      archiveHTML = this.addFooter(archiveHTML);
      return archiveHTML;
    },
    setTitle(pageHeader) {
      return `${pageHeader} \u2013 Fidelity Investments`;
    },
    saveUserInputs(agreeTermsHTML, taxWithHolding) {
      const checkToggle = 'id="agreementToggleYes" checked';
      let archiveHTML = agreeTermsHTML.replace('id="agreementToggleYes"', checkToggle);

      if (taxWithHolding === true) {
        const checkTaxWithHolding = 'id="inputagreement" checked';
        archiveHTML = archiveHTML.replace('id="inputagreement"', checkTaxWithHolding);
      }
      return archiveHTML;
    },
    saveRCPageUserInputs(reviewConfirmHTML, cashPosition, taxWithHolding) {
      const checkCorePositionRadio = `name="${cashPosition}-radio" checked`;
      const hideExitModal = 'id="exit-overlay-modal" style="display: none;"';
      const hideQuestionsModal = 'id="question-overlay-modal" style="display: none;"';
      let archiveHTML = reviewConfirmHTML.replace('id="exit-overlay-modal"', hideExitModal);
      archiveHTML = archiveHTML.replace('id="question-overlay-modal"', hideQuestionsModal);
      archiveHTML = archiveHTML.replace(`name="${cashPosition}-radio"`, checkCorePositionRadio);
      if (taxWithHolding) {
        if (this.routeId === 'youth') {
          archiveHTML = archiveHTML.replace(`name="${constants.YOUTH_TAX_AGREEMENT}"`, `name="${constants.YOUTH_TAX_AGREEMENT}" checked`);
        } else {
          archiveHTML = archiveHTML.replace('id="inputagreement"', 'id="inputagreement" checked');
        }
      }
      archiveHTML = archiveHTML.replace(`name="${constants.YOUTH_PARENT_AGREEMENT}"`, `name="${constants.YOUTH_PARENT_AGREEMENT}" checked`);
      archiveHTML = archiveHTML.replace(`name="${constants.YOUTH_CHILD_AGREEMENT}"`, `name="${constants.YOUTH_CHILD_AGREEMENT}" checked`);
      archiveHTML = this.addSVGIconForCheckbox(archiveHTML);
      archiveHTML = stripHtml(`${archiveHTML}`, {
        onlyStripTags: [
          'script',
          'iframe',
        ],
      }).result;
      return archiveHTML;
    },
    addSVGIconForCheckbox(htmlStr) {
      return htmlStr.split('icon="checkmark"></pvd-icon>').join('icon="checkmark"><span><svg aria-label="checkmark" viewBox="0 0 16 16" preserveAspectRatio="xMidYMid meet" focusable="false" role="img"><g id="checkmark" viewBox="0 0 16 16"><title>Checkmark Icon</title>;<rect width="16" height="16" fill="none"></rect><path d="M5.75,11.5,2.5587,7.8854a.8488.8488,0,0,0-1.2912,0,1.1,1.1,0,0,0,0,1.4377l3.9331,4.3791a.8484.8484,0,0,0,1.2838.0082l8.2408-8.9668A1.1,1.1,0,0,0,14.74,3.3061.8489.8489,0,0,0,13.4488,3.29Z"></path></g></svg></span></pvd-icon>');
    },
    addHeader(htmlWithNoHeader) {
      const header = '<pvd-header title="" hide-login="true">'
          + '<style>:host{display:block;width:100%}pvd-header{display:block;width:100%}.hidden{display:none !important}sup,sub{line-height:0}header{display:grid;display:-ms-grid;grid-template-rows:auto;-ms-grid-rows:auto;grid-template-columns:115px calc(100% - 215px) 100px;-ms-grid-columns:115px calc(100% - 215px) 100px;background-color:#568200;padding:1em;align-items:center}header a{text-decoration:none;display:flex}header p{padding-top:0;margin-top:0;color:#fff;display:inline-block;margin-bottom:0}header .header-logo{display:flex;align-items:center;grid-column:1;-ms-grid-column:1;grid-row:1;-ms-grid-row:1}header .header-logo a.header-home-link{line-height:1em;display:flex}header .header-logo pvd-icon.fidelity-logo{color:#fff;width:7.125em;height:1.75em}header .header-title{grid-row:2;-ms-grid-row:2;grid-column:span 3;-ms-grid-column:1;-ms-grid-column-span:3}header .header-title p{font-size:1em;margin-bottom:0;margin-top:0;line-height:1.375em;padding-top:.5em}@media screen and (min-width: 32em){header .header-title p{font-size:1.125em}}@media screen and (min-width: 60em){header .header-title p{font-size:1.3125em}}header .header-login{grid-column:3;-ms-grid-column:3;grid-row:1;-ms-grid-row:1;text-align:right}header .header-login a{font-size:.875em;display:flex;justify-content:flex-end;align-items:center;color:#fff}@media screen and (min-width: 32em){header .header-login a{font-size:1em}}@media screen and (min-width: 60em){header .header-login a{font-size:1.125em}}header .header-login pvd-icon{width:1em;height:1em;margin-right:0.5em}header.hide-login .header-login{display:none}@media screen and (min-width: 32em){header .header-title{grid-row:1;-ms-grid-row:1;grid-column:2;-ms-grid-column:2;-ms-grid-column-span:1;border-left:1px solid #fff;margin-left:0.5em;padding-left:1em}header .header-title:empty{border:none}header .header-title p{padding-top:0}}</style>'
          + '<header class="hide-login">'
          + '<div class="header-logo">'
          + '<slot name="header-logo"><pvd-icon icon="fidelity-investments" class="fidelity-logo" iconset="brand">'
          + '<style>:host{display: inline-block;fill: currentColor;stroke: none;width: 1em;height: 1em;position: relative;}:host(:focus){outline: dotted 1px #000;}pvd-icon:focus {outline: dotted 1px #000;}pvd-icon {display: inline-block;fill: currentColor;stroke: none;width: 1em;height: 1em;position: relative;}@media print {:host {color: #000 !important;}pvd-icon {color: #000 !important;}}</style>'
          + '<span><svg aria-label="fidelity-investments" viewBox="0 0 116 28" preserveAspectRatio="xMidYMid meet" focusable="false" role="img"><g id="fidelity-investments" viewBox="0 0 116 28"><rect width="116" height="28" fill="none"></rect><path d="M18.7,8.8H11l1-3.7h7.7L21.1,0H5.9L0,21.7h7.4l2.2-8.1h7.7L18.7,8.8"></path><path d="M30.4,0h-7.3l-1.2,4.3h7.3L30.4,0"></path><path d="M21.5,5.8l-4.3,15.8h7.3l4.3-15.8H21.5"></path><path d="M42,0l-2,7.6c-0.6-1.2-2.1-2.1-4.2-2.1c-2.4,0-4.5,1.1-5.6,3.2c-1.6,2.8-2.6,6.9-2.6,9.6 c0,2.5,1.5,3.6,3.9,3.6s3.8-0.9,5.3-2.1l-0.5,1.8h7.2l5.9-21.7L42,0L42,0L42,0z M37.7,16.4c-0.3,0.2-0.7,0.4-1.2,0.4 c-0.7,0-1.1-0.5-1.1-1.1c0-1.3,0.5-2.6,1-4c0.4-0.9,1-1.1,1.7-1.1c0.5,0,0.9,0.3,1.2,0.6L37.7,16.4L37.7,16.4z"></path><path d="M64.1,14.8c0.4-1.3,0.8-3.4,0.8-4.4c0-4-2.9-4.9-7.5-4.9c-2.9,0-6.2,0.9-8,3.4c-1.5,2.1-2.7,6-2.7,8.3 c0,4.3,3.4,4.9,7.7,4.9c3.2,0,8.4-1.5,9.3-6h-7.2c-0.3,1.5-0.7,1.9-1.8,1.9c-1,0-1.1-0.8-1.1-1.1c0-0.7,0.2-1.2,0.4-2.1H64.1 L64.1,14.8L64.1,14.8z M56.8,9.4c0.8,0,1.3,0.3,1.3,1.1c0,0.3-0.1,0.8-0.2,1.1h-3C55.2,10.1,55.8,9.4,56.8,9.4L56.8,9.4z"></path><path d="M70.1,0l-5.9,21.7h7.3L77.3,0H70.1"></path><path d="M87.1,0h-7.3l-1.2,4.3h7.3L87.1,0"></path><path d="M78.2,5.8l-4.4,15.9h7.3l4.3-15.8L78.2,5.8"></path><path d="M110.7,18.5c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S111.8,18.5,110.7,18.5L110.7,18.5z M110.7,22.2 c-0.9,0-1.6-0.8-1.6-1.7s0.7-1.7,1.6-1.7s1.6,0.8,1.6,1.7C112.3,21.5,111.6,22.2,110.7,22.2L110.7,22.2z"></path><path d="M111.4,20.1c0-0.4-0.2-0.6-0.7-0.6h-0.8v2.1h0.4v-0.9h0.3l0.5,0.9h0.4l-0.6-0.9 C111.2,20.7,111.4,20.5,111.4,20.1L111.4,20.1z M110.3,20.4v-0.6h0.3c0.2,0,0.5,0,0.5,0.3c0,0.3-0.3,0.3-0.5,0.3H110.3L110.3,20.4 L110.3,20.4z"></path><path d="M108.8,5.8l-4,8.8l0.1-8.8h-10l1-3.5h-7.3l-4,14.4c-0.2,0.9-0.3,1.6-0.3,2.3c0,1.6,0.8,2.7,3,2.7h6.5l1.1-3.9 h-1.6c-1,0-1.3-0.2-1.3-0.9c0-0.4,0.1-1,0.3-1.4l1.6-6h4l1.1,12.3c-0.2,0.9-0.5,1.4-1,1.7c-0.6,0.3-2,0.2-2.5,0.2h-0.1L94.2,28h5 c2.9,0,4.4-1.5,6.5-4.9l10.7-17.2L108.8,5.8L108.8,5.8"></path></g></svg></span>'
          + '</pvd-icon></slot>'
          + '</div>'
          + `<div class="header-title"><p>${this.pd_content.site_header_text}</p></div>`
          + '<div class="header-login">'
          + '<a href="javascript:void(0)">'
          + '<pvd-icon icon="lock"></pvd-icon> Log In'
          + '</a>'
          + '</div>'
          + '</header></pvd-header>';
      let archiveHTML = htmlWithNoHeader;
      archiveHTML = archiveHTML.replace(/<pvd-header.*<\/pvd-header>/g, header);
      return archiveHTML;
    },
    addFooter(htmlWithNoFooter) {
      const currentTime = new Date().toString();
      let footer;
      if (!this.isNetBenefits) {
        footer = '<pvd-footer><footer>'
          + '<style>a{color:#0E67A9;text-decoration:none}a:not(:disabled):hover{text-decoration:underline}a:not(:disabled):focus,a:not(:disabled):active{outline:dotted 1px #000;border:none;box-shadow:none}a:visited{color:#5c0198}a>pvd-icon{transform:translateY(0.125em)}a.pvd-truncate-action{font-size:0.75rem}:host{display:block;width:100%}pvd-footer{display:block;width:100%}.hide{display:none !important}footer{display:grid;display:-ms-grid;background-color:#f2f2f2;padding:1em;grid-template-columns:100%;-ms-grid-columns:100%;grid-template-rows:auto;-ms-grid-rows:auto}footer .footer__logo{grid-column:1;-ms-grid-column:1;grid-row:1;-ms-grid-row:1;text-align:center;margin-bottom:1em}footer .footer__logo img{height:33px;width:152px}footer .footer__links{text-align:center;grid-column:1;-ms-grid-column:1;grid-row:2;-ms-grid-row:2}footer .footer__links a{color:#0E67A9}footer .footer__links p{font-size:0.75em;margin:0;color:inherit}footer .footer__links p.copyright{margin-top:0;padding-top:0}footer .footer__links .links p{display:inline-block;line-height:1.5em;margin:0.5em 0}footer .footer__links .links p::after{content:"|";margin-left:0.5em;margin-right:0.5em;color:#ccc}footer .footer__links .links p:last-child::after{content:"";margin-left:0;margin-right:0}@media screen and (min-width: 32em){footer{grid-template-columns:auto auto;-ms-grid-columns:25% 75%;grid-template-rows:auto;-ms-grid-rows:auto}footer .footer__logo{grid-column:1;-ms-grid-column:1;grid-row:1;-ms-grid-row:1;text-align:left}footer .footer__links{text-align:right;grid-column:2;-ms-grid-column:2;grid-row:1;-ms-grid-row:1}}</style>'
          + '<div class="footer__logo">'
          + '<img aria-label="Fidelity Investments" role="img" src="data:image/svg+xml;base64,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" alt="Fidelity FMR">'
          + '</div>'
          + '<div class="footer__links">'
          + '<p class="copyright">Copyright 1998-2019 FMR LLC. All rights reserved.</p>'
          + '<div class="links">'
          + '<p><a href="javascript:void(0)">Terms of Use</a></p>'
          + '<p><a href="javascript:void(0)">Privacy</a></p>'
          + '<p><a href="javascript:void(0)">Security</a></p>'
          + '<p><a href="javascript:void(0)">Site Map</a></p>'
          + '<p><a href="javascript:void(0)">Accessibility</a></p>'
          + '<p><a href="javascript:void(0)">Contact Us</a></p>'
          + '</div>'
          + '<p><a href="javascript:void(0)">This is for persons in the U.S. only.</a></p>'
          + `<p>${currentTime}</p>`
          + '</div>'
          + '</footer>';
      } else {
        footer = '<pvd-footer><footer>'
          + '<style>a{color:#0E67A9;text-decoration:none}a:not(:disabled):hover{text-decoration:underline}a:not(:disabled):focus,a:not(:disabled):active{outline:dotted 1px #000;border:none;box-shadow:none}a:visited{color:#5c0198}a>pvd-icon{transform:translateY(0.125em)}a.pvd-truncate-action{font-size:0.75rem}:host{display:block;width:100%}pvd-footer{display:block;width:100%}.hide{display:none !important}footer{display:grid;display:-ms-grid;background-color:#f2f2f2;padding:1em;grid-template-columns:100%;-ms-grid-columns:100%;grid-template-rows:auto;-ms-grid-rows:auto}footer .footer__logo{grid-column:1;-ms-grid-column:1;grid-row:1;-ms-grid-row:1;text-align:center;margin-bottom:1em}footer .footer__logo img{height:39px;width:115px}footer .footer__links{text-align:center;grid-column:1;-ms-grid-column:1;grid-row:2;-ms-grid-row:2}footer .footer__links a{color:#0E67A9}footer .footer__links p{font-size:0.75em;margin:0;color:inherit}footer .footer__links p.copyright{margin-top:0;padding-top:0}footer .footer__links .links p{display:inline-block;line-height:1.5em;margin:0.5em 0}footer .footer__links .links p::after{content:"|";margin-left:0.5em;margin-right:0.5em;color:#ccc}footer .footer__links .links p:last-child::after{content:"";margin-left:0;margin-right:0}@media screen and (min-width: 32em){footer{grid-template-columns:auto auto;-ms-grid-columns:25% 75%;grid-template-rows:auto;-ms-grid-rows:auto}footer .footer__logo{grid-column:1;-ms-grid-column:1;grid-row:1;-ms-grid-row:1;text-align:left}footer .footer__links{text-align:right;grid-column:2;-ms-grid-column:2;grid-row:1;-ms-grid-row:1}}</style>'
          + '<div class="footer__logo">'
          + '<img aria-label="Powered by Fidelity Investments" role="img" src="data:img/png;base64,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">'
          + '</div>'
          + '<div class="footer__links">'
          + '<p class="copyright">Copyright 1998-2019 FMR LLC. All rights reserved.</p>'
          + '<div class="links">'
          + '<p><a target="_blank" href="javascript:void(0)">Terms of Use</a></p>'
          + '<p><a target="_blank" href="javascript:void(0)">Privacy</a></p>'
          + '<p><a target="_blank" href="javascript:void(0)">Security</a></p>'
          + '<p><a target="_blank" href="javascript:void(0)">Accessibility</a></p>'
          + '<p><a target="_blank" href="javascript:void(0)">Contact Us</a></p>'
          + '</div>'
          + '<p class="us-only hide"><a href="javascript:void(0)">This is for persons in the U.S. only.</a></p>'
          + `<p>${currentTime}</p>`
          + '</div>'
          + '</footer>';
      }

      let archiveHTML = htmlWithNoFooter;
      archiveHTML = archiveHTML.replace(/<pvd-footer.*<\/pvd-footer>/g, footer);
      return archiveHTML;
    },
    isNetBenefits() {
      const netBenefitsRegTypes = ['iStock'];
      return netBenefitsRegTypes.includes(window.params.rt);
    },
    isManaged(routeId) {
      return routeId === 'managed';
    },
    isTrust(routeId) {
      return routeId === 'trust';
    },
    hasManagedProspectuses(productType) {
      switch (productType) {
        case 'ETFBDI':
        case 'ETFMAI':
        case 'UFD':
          return true;
        default:
          return false;
      }
    },
    isIStock(routeId) {
      return routeId === 'iStock';
    },
    populateCountryList(componentId) {
      const component = document.querySelector(componentId);
      // Reset options before populating in the case that component has previously been populated.
      component.options = [];

      this.pd_countryList.validCitizenship.forEach((element) => {
        component.options.push({ label: element.option, value: element.value });
      });
    },
    getCountryList() {
      return this.pd_countryList.validCitizenship.map((element) => ({
        label: element.option,
        value: element.value,
      }));
    },
    populateAssociationList(componentId, listOfObj) {
      const component = document.querySelector(componentId);
      component.listOfItems = [];
      Object.keys(listOfObj).forEach((key) => {
        component.listOfItems.push(key);
      });
    },
    populateIdFromMap(name, mapObject) {
      const value = mapObject[name];
      return value;
    },
    populateStateList(componentId) {
      const component = document.querySelector(componentId);
      for (let i = 1; i < this.pd_statesList.length; i += 1) {
        component[this.pd_statesList[i].value] = this.pd_statesList[i].option;
      }
    },
    populateEmploymentStatuses(componentId) {
      const component = document.querySelector(componentId);
      if (this.pd_content.employment_statuses) {
        this.pd_content.employment_statuses.forEach((element) => {
          component.options.push({ label: element.option, value: (element.value === undefined ? '' : element.value) });
        });
      }
    },
    sortObjectByKey(object) {
      return Object.keys(object)
        .sort()
        .reduce((accumulator, key) => ({
          ...accumulator, [key]: object[key],
        }), {});
    },
    isRetailRegType(regType) {
      const retailRegTypes = {
        rolloverIRA: true,
        tradIRA: true,
        rothIRA: true,
        rothForKids: true,
        inheritedRothIra: true,
        inheritedTradIra: true,
        sepIRA: true,
        brokerageIndividual: true,
        brokerageJoint: true,
        youth: true,
        myScaIndividual: true,
        myScaJoint: true,
        bundleBrokerageIndividual: true,
        bundleBrokerageJoint: true,
        '529Custodial': true,
        '529Individual': true,
        custodial: true,
        retailHsa: true,
      };
      return !!retailRegTypes[regType];
    },
    shouldCall2FAWidget(stateName, isCustomer, isRep, routeId) {
      if (stateName === 'personal-information' && !isCustomer
        && !isRep && this.isRetailRegType(routeId)) {
        return true;
      }
      return false;
    },
    loadExternalScript(scriptPath) {
      const scriptEle = document.querySelector(`script[src="${scriptPath}"]`);
      if (scriptEle) {
        const head = document.getElementsByTagName('head')[0];
        if (head) {
          head.removeChild(scriptEle);
        }
      }
      const recaptchaScript = document.createElement('script');
      recaptchaScript.setAttribute('src', scriptPath);
      document.head.appendChild(recaptchaScript);
      return recaptchaScript;
    },
    toText(str) {
      const div = document.createElement('div');
      div.innerHTML = str;
      return div.textContent;
    },
    configureBackButtonFunctionality(callback) {
      if (window.history && window.history.pushState) {
        window.history.pushState(null, null, document.location.href);
        window.onpopstate = () => {
          window.history.forward();
          if (this.backButtonAttempt === false) {
            this.backButtonAttempt = true;
            callback();
          } else {
            this.backButtonAttempt = false;
          }
        };
      }
    },
    getRegType(url) {
      let regType;
      if (url && url.indexOf('iStock') !== -1) {
        regType = constants.ISTOCK_REGTYPE;
      } else if (url && url.indexOf('rolloverIRA') !== -1) {
        regType = constants.ROLLOVERIRA_REGTYPE;
      }
      return regType;
    },
    showBackWarning(msg) {
      // eslint-disable-next-line no-alert
      alert(msg);
    },
    configureFirstPageBackButton(callback) {
      window.history.pushState(null, null, document.location.href);
      window.history.back();
      window.alertCounter = 0;
      if (window.history && window.history.pushState) {
        window.onpopstate = () => {
          window.history.forward();
          window.alertCounter += 1;
          if (this.backButtonAttempt === false && window.alertCounter > 2) {
            this.backButtonAttempt = true;
            callback();
          } else {
            this.backButtonAttempt = false;
          }
        };
      }
    },
    removeModalClassIfExists() {
      const bodyTag = document.querySelector('body.layer-modal-open');
      if (bodyTag && bodyTag.classList) {
        bodyTag.classList.remove('layer-modal-open');
      }
    },
    /**
     * Safely fetch the object keys recursively and returns false if doesn't exist
     * @param {Object} obj - The source object
     * @param {string} path - recursive objects & propertty
     */
    safeObjectGet(obj, path) {
      if (!obj || !path) {
        return false;
      }
      const splitPath = path.split('.');
      const nextObj = obj[splitPath[0]];
      if (nextObj) {
        if (splitPath.length === 1) return nextObj;
        const remainingPath = splitPath.slice(1).join('.');
        return this.safeObjectGet(nextObj, remainingPath);
      }
      return false;
    },
    formatSigStatusDate(dateString) {
      return format(parse(dateString), 'MMM-DD-YYYY');
    },
    subtractNow(years, type) {
      const dt = moment(new Date()).subtract(years, 'year');
      if (type && type === 'min') {
        dt.add(1, 'day');
      }
      return dt.format('MM/DD/YYYY');
    },
    replaceText(source, search, replace) {
      if (!source) {
        return '';
      }
      if (!search) {
        return source;
      }
      return source.split(search).join(replace);
    },

    createForm(path, data) {
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = path;

      const generateFormFields = (obj) => {
        Object.keys(obj).forEach((key) => {
          if (typeof obj[key] === 'object') {
            // eslint-disable-next-line no-unused-vars
            generateFormFields(obj[key]);
          } else {
            const hiddenField = document.createElement('input');
            hiddenField.type = 'hidden';
            hiddenField.name = key;
            hiddenField.value = obj[key];
            form.appendChild(hiddenField);
          }
        });
      };
      if (data) {
        generateFormFields(data);
      }
      return form;
    },

    submitForm(form) {
      document.body.appendChild(form);
      form.submit();
    },

    fixApexToggleAlignmment(id) {
      // I know we shouldn't interact with the DOM in Vue, but Apex doesn't want to support it for whatever reason?
      // And take a look around, there's barely a function on this page that doesn't interact with the DOM.
      // This fixes the toggle buttons and centers them.
      // Please don't associate my name with the code of this application. Most of what I did was for consistency's sake.
      document.querySelector(`#${id} .form-row-stacked`)?.classList?.remove('form-row-stacked');
      document.querySelector(`#${id} .toggle-button-stacked`)?.classList?.remove('form-row-label');
      document.querySelector(`#${id} .toggle-button-stacked`)?.classList?.add('form-row-label-group');
    },

    handleEditClick(pageName, userIndex, futureDestinationState) {
      this.$store.commit('currentState/updateField', { path: 'destinationState', value: pageName });
      this.$store.commit('currentState/updateField', { path: 'editMode', value: true });
      this.$store.commit('currentState/updateField', { path: 'navAction', value: '' });
      if (typeof this.userIndex !== 'undefined') {
        this.$store.commit('currentState/updateField', { path: 'userIndex', value: userIndex });
        this.$store.commit('currentState/updateField', { path: 'currentUserIndex', value: userIndex });
      }
      if (typeof this.futureDestinationState !== 'undefined') {
        this.$store.commit('currentState/updateField', { path: 'futureDestinationState', value: futureDestinationState });
      }

      this.routeEngine(this.getInstanceData());
    },

    // This method is used for identifying whether the request is from Maestro
    isMaestro() {
      if (window.queries) {
        return window.queries.source === 'maestro';
      }
      return false;
    },

    isLiteView() {
      if (window.queries) {
        return window.queries.view === 'lite';
      }
      return false;
    },

    isPromotionalValidForRegtype(promoCodeToggle) {
      return promoCodeToggle && (this.routeId === 'brokerage' || this.routeId === 'fcma' || this.routeId === 'tradIRA' || this.routeId === 'rothIRA');
    },
  },
};
